// extracted by mini-css-extract-plugin
module.exports = {"option":"styles_option__xeuWD","selected":"styles_selected__h2k34"};